// src/virtual-agent/context.tsx
import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { openChatWidget, setVacFrameVisibilityHidden } from "@shared-ui/customer-virtual-agent-control";

// ../internal/src/utils/virtual-agent-helper/virtual-agent-control-helpers.ts
var sendMessage = async (data, logEvents) => {
  var _a, _b;
  if (((_a = window == null ? void 0 : window.VirtualAgentControl) == null ? void 0 : _a.initialized) && (window == null ? void 0 : window.VacClientAdapter)) {
    const isInit = await window.VirtualAgentControl.initialized;
    if (isInit) {
      const chatInstance = await window.VacClientAdapter.getInstance();
      if (await chatInstance.isInitialized) {
        logEvents == null ? void 0 : logEvents.SENDING_MESSAGE.log({
          message: `Sending message - ${data.text}`
        });
        (_b = chatInstance == null ? void 0 : chatInstance.vacFrame) == null ? void 0 : _b.sendMessage(data);
        return;
      }
    }
  }
  logEvents == null ? void 0 : logEvents.VAC_NOT_INITIALISED.log({
    message: `VAC is not initialised when trying to send message - ${data.text}`
  });
};

// src/virtual-agent/config.ts
var REQUIRED_EVENT = ["VAC_ConversationCreated" /* CONVERSATION_CREATED_EVENT */];

// src/virtual-agent/context.tsx
var defaultContextValue = {
  config: {
    eventHandler: () => console.error("Help Center VA Context Util not yet initialized")
  },
  controller: {
    sendMessage: () => console.error("Help Center VA Context Util not yet initialized")
  }
};
var VirtualAgentContext = createContext(defaultContextValue);
var VirtualAgentContextProvider = ({
  children
}) => {
  const [vaEvent, setVaEvent] = useState();
  const [conversationCreated, setConversationCreated] = useState(false);
  const [message, setMessage] = useState();
  const sendMessage2 = useCallback(input => {
    openChatWidget();
    setVacFrameVisibilityHidden(false);
    if (conversationCreated) {
      sendMessage(input);
      setMessage(void 0);
    } else {
      setMessage(input);
    }
  }, [conversationCreated, setMessage]);
  useEffect(() => {
    if (message) {
      sendMessage(message);
    }
  }, [conversationCreated]);
  useEffect(() => {
    if (!vaEvent) {
      return;
    }
    switch (vaEvent.type) {
      case "VAC_ConversationCreated" /* CONVERSATION_CREATED_EVENT */:
        setConversationCreated(true);
        break;
    }
  }, [vaEvent]);
  const vaContextValue = useMemo(() => ({
    config: {
      eventHandler: setVaEvent
    },
    controller: {
      sendMessage: sendMessage2
    }
  }), [sendMessage2, setVaEvent]);
  return /* @__PURE__ */React.createElement(VirtualAgentContext.Provider, {
    value: vaContextValue
  }, children);
};
var useVirtualAgentContext = () => useContext(VirtualAgentContext);

// src/virtual-agent/mock-context.tsx
import React2, { useMemo as useMemo2 } from "react";
var MockVirtualAgentContextProvider = ({
  mockController,
  mockConfig,
  children
}) => {
  const vaContextValue = useMemo2(() => ({
    config: {
      eventHandler: (mockConfig == null ? void 0 : mockConfig.eventHandler) || (() => console.warn("config.eventHandler not set"))
    },
    controller: {
      sendMessage: (mockController == null ? void 0 : mockController.sendMessage) || (() => console.warn("controller.sendMessage not set"))
    }
  }), [mockController]);
  return /* @__PURE__ */React2.createElement(VirtualAgentContext.Provider, {
    value: vaContextValue
  }, children);
};
export { MockVirtualAgentContextProvider, REQUIRED_EVENT, VirtualAgentContextProvider, useVirtualAgentContext };
/* istanbul ignore file -- @preserve */
//# sourceMappingURL=index.js.map